<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="export-box">
      <!-- <div class="title">导出案例信息：{{ type == 1 ? "(药品) " : "(sku) " }}</div> -->
      <div class="title">导出案例信息：{{ typeList[type] }}</div>
      <el-form v-if="type == 1" ref="pgc-search-form" :model="form" label-width="90px" class="export-search">
        <el-form-item label="drugId:">
          <el-input style="width: 250px" v-model="form.drugId" placeholder="请输入drugId"></el-input>
        </el-form-item>
        <el-form-item label="通用名:">
          <el-input style="width: 250px" v-model="form.genericName" placeholder="请输入通用名"></el-input>
        </el-form-item>
        <el-form-item label="品牌名:">
          <el-input style="width: 250px" v-model="form.tradeName" placeholder="请输入品牌名"></el-input>
        </el-form-item>
        <el-form-item label="类目:">
          <el-select style="width: 250px" class="select-role" v-model="form.virtualCatId" placeholder="请选择类目">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSumit">确认导出</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="type == 2" ref="pgc-search-form" :model="form" label-width="90px" class="export-search">
        <el-form-item label="skuId:">
          <el-input style="width: 250px" v-model="form.skuId" placeholder="请输入skuId"></el-input>
        </el-form-item>
        <el-form-item label="类目:">
          <el-select style="width: 250px" class="select-role" v-model="form.virtualCatId" placeholder="请选择类目">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSumit">确认导出</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="type == 3" ref="pgc-search-form" :model="form" label-width="90px" class="export-search">
        <el-form-item label="skuId:">
          <el-input style="width: 250px" v-model="form.skuId" placeholder="请输入skuId"></el-input>
        </el-form-item>
        <el-form-item label="类目:">
          <el-select style="width: 250px" class="select-role" v-model="form.virtualCatId" placeholder="请选择类目">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSumit">确认导出</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="type == 4" ref="pgc-search-form" :model="form" label-width="90px" class="export-search">
        <el-form-item label="skuId:">
          <el-input style="width: 250px" v-model="form.skuId" placeholder="请输入skuId"></el-input>
        </el-form-item>
        <el-form-item label="类目:">
          <el-select style="width: 250px" class="select-role" v-model="form.virtualCatId" placeholder="请选择类目">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSumit">确认导出</el-button>
        </el-form-item>
      </el-form>
      <p>导出数据时间会根据数据量增加，建议合理添加筛选条件！！！</p>
    </div>
  </div>
</template>

<script>
import breadCrumb from "../../../../components/breadCrumb";
import { pcdDrugExportQuestionAndAnswer, pcdSkuExportQuestionAndAnswer,
  pcdChildExportQuestionAndAnswer,pcdPetExportQuestionAndAnswer
 } from '../../../../api/man.js';
export default {
  name: "pgcExport",
  components: {
    breadCrumb
  },
  data() {
    return {
      type: new URLSearchParams(window.location.search).get('type'),
      typeList: ['', '(药品) ', '(SKU) ', '(宠物案例管理SKU) ', '(婴幼儿用户案例管理SKU) '],
      uploadShow: false,
      form: new URLSearchParams(window.location.search).get('type') == 1 ?
        {
          drugId: '',
          genericName: '',
          tradeName: '',
          // manufacturer: '',
          virtualCatId: ''
        } : {
          skuId: '',
          skuName: '',
          virtualCatId: ''
        },
      options: [
        {
          label: '医药',
          value: 1
        },
        {
          label: '保健',
          value: 2
        },
        {
          label: '器械',
          value: 3
        },
      ],

    }
  },
  methods: {
    // 导出商品
    onSumit() {
      if(this.type == 1) {
        pcdDrugExportQuestionAndAnswer({
          ...this.form,
        }).then(res => {
          console.log('res', res);
          if (res) {
            this.$message({
              message: '导出成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/pgc/record'
              })
            }, 300);
          }
        })
      } else if(this.type == 2) {
        pcdSkuExportQuestionAndAnswer({
          ...this.form,
        }).then(res => {
          console.log('res', res);
          if (res) {
            this.$message({
              message: '导出成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/pgc/record'
              })
            }, 300);
          }
        })
      } else if(this.type == 3) {
        pcdPetExportQuestionAndAnswer({
          ...this.form,
        }).then(res => {
          console.log('res', res);
          if (res) {
            this.$message({
              message: '导出成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/pgc/record'
              })
            }, 300);
          }
        })
      } else if(this.type == 4) {
        pcdChildExportQuestionAndAnswer({
          ...this.form,
        }).then(res => {
          console.log('res', res);
          if (res) {
            this.$message({
              message: '导出成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/pgc/record'
              })
            }, 300);
          }
        })
      }
      // this.type == 1 ?
      //   pcdDrugExportQuestionAndAnswer({
      //     ...this.form,
      //   }).then(res => {
      //     console.log('res', res);
      //     if (res) {
      //       this.$message({
      //         message: '导出成功',
      //         type: 'success'
      //       })
      //       setTimeout(() => {
      //         this.$router.push({
      //           path: '/pgc/record'
      //         })
      //       }, 300);
      //     }
      //   }) :
      //   pcdSkuExportQuestionAndAnswer({
      //     ...this.form,
      //   }).then(res => {
      //     console.log('res', res);
      //     if (res) {
      //       this.$message({
      //         message: '导出成功',
      //         type: 'success'
      //       })
      //       setTimeout(() => {
      //         this.$router.push({
      //           path: '/pgc/record'
      //         })
      //       }, 300);
      //     }
      //   })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-box {
  padding: 20px 0 20px 33px;
  background: #fff;
  box-shadow: 0 0 6px rgba(229, 227, 227, 0.79);
  overflow: hidden;
  margin-top: 15px;

  .title {
    margin-bottom: 10px;
  }

  .export-search {
    display: flex;
    align-items: center;
  }

  p {
    color: red;
    font-size: 12px;
    margin-top: 5px;
  }

}
</style>
